import { call, put } from 'redux-saga/effects';
import {
  fetchTransactionAttachmentFailure,
  fetchTransactionAttachmentRequest,
  fetchTransactionAttachmentSuccess,
} from '../actions';
import { ApiError } from 'store/api/types';
import { Provider } from 'store/api/enums';
import { UploadTransactionAttachmentRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import {
  uploadTransactionAttachment,
  TransactionAttachmentsResponse,
} from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { TransactionAttachment } from '../models/transactionAttachments';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* uploadTransactionAttachmentSaga(
  action: UploadTransactionAttachmentRequestAction
) {
  try {
    let err: ApiError | null;
    const { tokenId, transactionId, transactionUuid, provider, file, sourceType } =
      action.payload;

    const response: TransactionAttachmentsResponse = yield call(
      uploadTransactionAttachment,
      tokenId,
      transactionId,
      transactionUuid,
      file,
      sourceType
    );

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    // VAT: success/failure based on response.data.files
    if (response.data?.files && response.data.files.length > 0) {
      const transactionAttachments: TransactionAttachment[] =
        response.data.files;
      yield put(
        fetchTransactionAttachmentSuccess(
          transactionAttachments,
          transactionId,
          'upload'
        )
      );
    } else {
      yield put(fetchTransactionAttachmentFailure());
    }

    // Excel (entity) transactions: refetch whenever upload succeeded; do not gate on response.data.files
    const isExcelTransaction =
      provider?.toLowerCase() === Provider.EXCEL &&
      transactionId === transactionUuid;
    if (isExcelTransaction) {
      yield put(
        fetchTransactionAttachmentRequest(
          tokenId,
          transactionId,
          transactionUuid,
          provider,
          sourceType
        )
      );
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchTransactionAttachmentFailure());
  }
}
